import React, { Component } from 'react';

import Accordion from 'react-bootstrap/Accordion';
import Layout from 'src/components/layout';
import Disclaimer from '../../components/disclaimer';
import ConsumerPanel from '../../components/consumer-panel';

import { AppStateContext } from 'src/contexts/app-state-provider.context';
import { TranslatedBlock } from 'src/components/language';
import { TranslatableText } from '../../components/language';

import PersonalResourcesImg from '../../images/faq-banner.png';
import DownloadImg from '../../images/download-icon.svg';
import AudioIcon from '../../images/audio-icon.svg';
import PatientCareGiver from '../../images/patientcaregiver.svg';

import { BannerComponent } from '../../components/banner-component';
import './index.scss';
import ConsultDoctor from '../../components/consult-doctor';
import ThingsToKnow from '../../components/things-to-know';
import SideEffects from '../../components/side-effects';

class PatientPage extends Component {
  static contextType = AppStateContext;
  state = {
    isAudioVisible: false,
  };
  componentDidMount() {
    this.context.setSection('patient');
    this.context.setPage('faq');
  }

  render() {
    const title = {
      english: 'FAQ',
    };
    return (
      <Layout title={title} showNavbar={true} className="patient">
        <BannerComponent backgroundPhoto={PersonalResourcesImg} titleText="Frequently Asked Questions (FAQ)" />

        <div className="container pt-4 text-center fw-bold px-2">
          <p>
            These questions may help you get started with the conversation. Please note, any and all questions regarding
            VABYSMO should be discussed with your ophthalmologist.
          </p>
        </div>

        <div className="container mb-2 pb-2">
          <div className="firstAccordian">
            <h3 className="font-color-secondary-3">
              FAQs about wet AMD
              <br />{' '}
            </h3>
          </div>

          <Accordion>
            <Accordion.Item eventKey="0">
              <Accordion.Header>What is wet AMD?</Accordion.Header>
              <Accordion.Body>
                <p>
                  Wet AMD occurs when blood vessels grow abnormally in the eye causing blood and fluid to leak into the
                  macula, the part of the eye that controls sharp, straight-ahead vision.
                </p>
                <p>
                  Wet AMD is the leading cause of vision loss in people aged 60 and over, and can lead to severe vision
                  problems and even blindness if left untreated, but VABYSMO can help reduce the swelling and prevent
                  vision loss.
                </p>
              </Accordion.Body>
            </Accordion.Item>
            <Accordion.Item eventKey="1">
              <Accordion.Header>How does wet AMD affect my vision?</Accordion.Header>
              <Accordion.Body>
                <p>While wet AMD affects everyone differently, its symptoms may appear suddenly. They include:</p>

                <ul>
                  <li>Blurry or blind spots that appear in the central vision of the affected eye</li>
                  <li>Straight lines that appear wavy</li>
                  <li>Colours that appear less vibrant</li>
                  <li>Trouble seeing in low light.</li>
                </ul>
              </Accordion.Body>
            </Accordion.Item>
            <Accordion.Item eventKey="2">
              <Accordion.Header>What is “drying,” and why is it important?</Accordion.Header>
              <Accordion.Body>
                <p>
                  In wet AMD, blood and fluid can spill into the macula—the part of the eye that controls sharp,
                  straight-ahead vision.
                </p>
                <p>
                  The macula swells and leaks, leading to blurred vision and vision loss. VABYSMO can help quickly dry
                  the excess fluid.
                </p>
              </Accordion.Body>
            </Accordion.Item>
            <Accordion.Item eventKey="3">
              <Accordion.Header>What happens if I stop eye injections for wet AMD?</Accordion.Header>
              <Accordion.Body>
                <p>
                  Wet AMD is a chronic condition that requires long-term care. Keeping up with your treatment can
                  prevent blindness. Your Ophthalmologist can tell you more about what to expect from treatment with
                  VABYSMO.
                </p>
              </Accordion.Body>
            </Accordion.Item>
          </Accordion>
          <div>
            <h3 className="font-color-secondary-3">
              <br />
              FAQs about VABYSMO for Wet AMD
              <br />{' '}
            </h3>
          </div>

          <Accordion>
            <Accordion.Item eventKey="0">
              <Accordion.Header>What is VABYSMO?</Accordion.Header>
              <Accordion.Body>
                <p>
                  VABYSMO is a prescription medicine administered by injection into the eye by your Ophthalmologist.
                </p>
                <p>
                  In New Zealand it is registered for the treatment of wet age-related macular degeneration (nAMD),
                  diabetic macular oedema (DMO) and macular oedema secondary to retinal vein occlusion (RVO).
                </p>
              </Accordion.Body>
            </Accordion.Item>
            <Accordion.Item eventKey="1">
              <Accordion.Header>What are the serious side effects of VABYSMO?</Accordion.Header>
              <Accordion.Body>
                <p>VABYSMO may cause serious side effects, including:</p>
                <ul>
                  <li>
                    Pain, redness or blood around the coloured part of the eye bleeding into the eye causing a red tint
                    to your vision
                  </li>
                  <li>Blood or redness in the white part of the eye</li>
                  <li>
                    Increase in eye pressure – symptoms include severe headache, eye pain, nausea and vomiting, blurred
                    vision, eye redness
                  </li>
                  <li>scratch to the clear part at the front of the eye</li>
                  <li>
                    Inflammation of the gel-like substance at the back of the eye – symptoms include hazy vision or a
                    marked increase in floaters
                  </li>
                  <li>
                    Sudden onset of the following: eye pain, increased discomfort, worsening eye redness, a higher
                    number of floaters in your vision, or increased sensitivity to light – these are signs of a possible
                    eye infection or inflammation
                  </li>
                  <li>
                    Decrease or change in your vision which can be sudden or gradual, including dim vision, difficulty
                    with vision at night, fading sudden, brief flashes of light which is more likely to occur when you
                    move your eye, heavy feeling in the eye.
                  </li>
                </ul>
              </Accordion.Body>
            </Accordion.Item>
            <Accordion.Item eventKey="2">
              <Accordion.Header>What are the common side effects of VABYSMO?</Accordion.Header>
              <Accordion.Body>
                <ul>
                  <li>
                    The most common side effects with VABYSMO are cataract and blood on the white of the eye
                    (conjunctival haemorrhage).
                  </li>
                  <li>These are not all the possible side effects of VABYSMO.</li>
                </ul>
              </Accordion.Body>
            </Accordion.Item>
            <Accordion.Item eventKey="3">
              <Accordion.Header>How many injections will I receive with VABYSMO?</Accordion.Header>
              <Accordion.Body>
                <p>
                  For people with wet AMD, VABYSMO is given every month for the first 4 months. Afterwards, your
                  Ophthalmologist will personalise your treatment schedule based on your needs, with the chance to
                  receive as few as 3 injections per year after the first year of treatment has been completed.
                </p>
              </Accordion.Body>
            </Accordion.Item>
            <Accordion.Item eventKey="4">
              <Accordion.Header>How fast does VABYSMO work?</Accordion.Header>
              <Accordion.Body>
                <p>
                  Everyone is different, but studies show that VABYSMO may improve your vision after just 1 treatment.
                </p>
              </Accordion.Body>
            </Accordion.Item>
            <Accordion.Item eventKey="5">
              <Accordion.Header>How long will I need to receive VABYSMO?</Accordion.Header>
              <Accordion.Body>
                <p>
                  Wet AMD is a chronic condition that requires long-term care. Your Ophthalmologist can tell you more
                  about what to expect from treatment with VABYSMO.
                </p>
              </Accordion.Body>
            </Accordion.Item>
            <Accordion.Item eventKey="6">
              <Accordion.Header>What should I do if I experience a side effect?</Accordion.Header>
              <Accordion.Body>
                <p>Contact your Ophthalmologist if you think you might be experiencing any side effects.</p>

                <p>
                  Call your doctor straight away or go to your nearest Accident and Emergency Centre if you notice any
                  of the following:
                  <br />
                  sudden vision loss or change in vision; signs of a possible eye infection or inflammation, such as
                  worsening redness of the eye or blood in and around the eye, eye pain, increased eye discomfort,
                  blurred or decreased vision, an increased number of floaters (small particles) in your vision,
                  increased sensitivity to light; you experience signs of a stroke, such as weakness or paralysis of
                  limbs or face or difficulty speaking.
                </p>

                <p>
                  {' '}
                  For questions about Roche medicines or services, to report an adverse event (side effect) or product
                  quality defect or to submit a temperature excursion assessment, please visit MedInfo.roche.com or
                  phone 0800 276 243. Please refer to the Consumer Medicine Information on the{' '}
                  <a
                    href="https://www.medsafe.govt.nz/Consumers/CMI/v/vabysmo.pdf"
                    className="links"
                    title="Medsafe website"
                  >
                    Medsafe website
                  </a>{' '}
                  for product information applicable to New Zealand.
                </p>
              </Accordion.Body>
            </Accordion.Item>
            <Accordion.Item eventKey="7">
              <Accordion.Header>What if I am already on a treatment for my wet AMD?</Accordion.Header>
              <Accordion.Body>
                <p>
                  {' '}
                  If you are already on a vascular endothelial growth factor (VEGF) treatment, ask your Ophthalmologist
                  if switching to VABYSMO is right for you.
                </p>
              </Accordion.Body>
            </Accordion.Item>
            <Accordion.Item eventKey="8">
              <Accordion.Header>How much does VABYSMO cost?</Accordion.Header>
              <Accordion.Body>
                <p>
                  {' '}
                  VABYSMO is funded by PHARMAC for adults with wet AMD and DMO who meet predefined criteria. This means
                  there is no cost to the patient for the medicine itself. VABYSMO is not funded by PHARMAC for RVO.
                </p>
                <p>
                  {' '}
                  For patients ineligible for PHARMAC funded VABYSMO, Roche offers support through the VABYSMO Cost
                  Share Programme. The Programme helps with the cost of your medicine. Please speak with your
                  Ophthalmologist or nurse for details.
                </p>
                <p>
                  {' '}
                  If you have health insurance, check your policy carefully, as coverage can vary. Ask your
                  Ophthalmologist if VABYSMO is right for you. For more information, talk to your healthcare
                  professional or visit{' '}
                  <a
                    href="https://www.medsafe.govt.nz/Consumers/CMI/v/vabysmo.pdf"
                    className="links"
                    title="Medsafe website"
                  >
                    medsafe.govt.nz
                  </a>{' '}
                  for the VABYSMO Consumer Medicine Information
                </p>
              </Accordion.Body>
            </Accordion.Item>
          </Accordion>

          <div>
            <h3 className="font-color-secondary-3">
              <br />
              FAQs about Diabetic Macular Oedema (DMO)
              <br />{' '}
            </h3>
          </div>

          <Accordion>
            <Accordion.Item eventKey="0">
              <Accordion.Header>What is DMO?</Accordion.Header>
              <Accordion.Body>
                <p>
                  {' '}
                  DMO is a complication associated with diabetes. It occurs when consistently high blood sugar levels
                  damage the blood vessels in the eye causing fluid to leak into the macula, the part of the eye that
                  controls sharp, straight-ahead vision.
                </p>
                <p>
                  {' '}
                  If untreated, DMO can lead to severe vision problems and even blindness, but VABYSMO can help reduce
                  the swelling and prevent vision loss.
                </p>
              </Accordion.Body>
            </Accordion.Item>
            <Accordion.Item eventKey="1">
              <Accordion.Header>How does DMO affect my vision?</Accordion.Header>
              <Accordion.Body>
                <p> While DMO affects everyone differently, its symptoms include:</p>
                <ul>
                  <li>Blurry or blind spots appearing in the central vision of the affected eye</li>
                  <li>Straight lines that appear wavy</li>
                  <li>Colours that appear less vibrant</li>
                  <li>Trouble seeing in low light.</li>
                </ul>
              </Accordion.Body>
            </Accordion.Item>

            <Accordion.Item eventKey="2">
              <Accordion.Header>What is "drying" and why is it important?</Accordion.Header>
              <Accordion.Body>
                <p>
                  {' '}
                  In DMO, blood and fluid can spill into the macula—the part of the eye that controls sharp,
                  straight-ahead vision.
                </p>

                <p> The macula swells, leading to blurred vision and vision loss.</p>

                <p> VABYSMO can help quickly dry the excess fluid.</p>
              </Accordion.Body>
            </Accordion.Item>

            <Accordion.Item eventKey="3">
              <Accordion.Header>What happens if I stop eye injections for DMO?</Accordion.Header>
              <Accordion.Body>
                <p>
                  {' '}
                  It’s important to keep up with your treatment for DMO. Keeping up with your treatment can prevent
                  blindness. Your Ophthalmologist can tell you more about what to expect from treatment with VABYSMO.
                </p>
              </Accordion.Body>
            </Accordion.Item>
          </Accordion>

          <div>
            <h3 className="font-color-secondary-3">
              <br />
              FAQs about VABYSMO for Diabetic Macular Oedema (DMO)
              <br />{' '}
            </h3>
          </div>

          <Accordion>
            <Accordion.Item eventKey="0">
              <Accordion.Header>What is VABYSMO?</Accordion.Header>
              <Accordion.Body>
                <p>
                  {' '}
                  VABYSMO is a prescription medicine administered by injection into the eye by your Ophthalmologist.
                </p>
                <p>
                  {' '}
                  In New Zealand it is registered for the treatment of wet age-related macular degeneration (nAMD),
                  diabetic macular oedema (DMO) and macular oedema secondary to retinal vein occlusion (RVO).
                </p>
              </Accordion.Body>
            </Accordion.Item>
            <Accordion.Item eventKey="1">
              <Accordion.Header>What are the serious side effects of VABYSMO?</Accordion.Header>
              <Accordion.Body>
                <p> VABYSMO may cause serious side effects, including:</p>
                <ul>
                  <li>
                    Pain, redness or blood around the coloured part of the eye bleeding into the eye causing a red tint
                    to your vision
                  </li>
                  <li>Blood or redness in the white part of the eye</li>
                  <li>
                    Increase in eye pressure – symptoms include severe headache, eye pain, nausea and vomiting, blurred
                    vision, eye redness
                  </li>
                  <li>scratch to the clear part at the front of the eye</li>
                  <li>
                    Inflammation of the gel-like substance at the back of the eye – symptoms include hazy vision or a
                    marked increase in floaters
                  </li>
                  <li>
                    Sudden onset of the following: eye pain, increased discomfort, worsening eye redness, a higher
                    number of floaters in your vision, or increased sensitivity to light – these are signs of a possible
                    eye infection or inflammation
                  </li>
                  <li>
                    Decrease or change in your vision which can be sudden or gradual, including dim vision, difficulty
                    with vision at night, fading sudden, brief flashes of light which is more likely to occur when you
                    move your eye, heavy feeling in the eye.
                  </li>
                </ul>
              </Accordion.Body>
            </Accordion.Item>

            <Accordion.Item eventKey="2">
              <Accordion.Header>What are the common side effects of VABYSMO?</Accordion.Header>
              <Accordion.Body>
                <ul>
                  <li>
                    The most common side effects with VABYSMO are cataract and blood on the white of the eye
                    (conjunctival haemorrhage)
                  </li>
                  <li>These are not all the possible side effects of VABYSMO.</li>
                </ul>
              </Accordion.Body>
            </Accordion.Item>

            <Accordion.Item eventKey="3">
              <Accordion.Header>How many injections will I receive with VABYSMO?</Accordion.Header>
              <Accordion.Body>
                <p>
                  {' '}
                  For people with DMO, VABYSMO is given every month for the first 4 months. Afterwards, your
                  Ophthalmologist will personalise your treatment schedule based on your needs, with the chance to
                  receive as few as 3 injections per year after the first year of treatment has been completed.
                </p>
              </Accordion.Body>
            </Accordion.Item>

            <Accordion.Item eventKey="4">
              <Accordion.Header>How fast does VABYSMO work?</Accordion.Header>
              <Accordion.Body>
                <p>
                  {' '}
                  Everyone is different, but studies show that VABYSMO may improve your vision after just 1 treatment.
                </p>
              </Accordion.Body>
            </Accordion.Item>

            <Accordion.Item eventKey="5">
              <Accordion.Header>How long will I need to receive VABYSMO?</Accordion.Header>
              <Accordion.Body>
                <p>
                  {' '}
                  DMO is a chronic condition that requires long-term care. Your Ophthalmologist can tell you more about
                  what to expect from treatment with VABYSMO.
                </p>
              </Accordion.Body>
            </Accordion.Item>

            <Accordion.Item eventKey="6">
              <Accordion.Header>What should I do if I experience a side effect?</Accordion.Header>
              <Accordion.Body>
                <p>Contact your Ophthalmologist if you think you might be experiencing any side effects.</p>

                <p>
                  Call your doctor straight away or go to your nearest Accident and Emergency Centre if you notice any
                  of the following:
                  <br /> sudden vision loss or change in vision; signs of a possible eye infection or inflammation, such
                  as worsening redness of the eye or blood in and around the eye, eye pain, increased eye discomfort,
                  blurred or decreased vision, an increased number of floaters (small particles) in your vision,
                  increased sensitivity to light; you experience signs of a stroke, such as weakness or paralysis of
                  limbs or face or difficulty speaking.{' '}
                </p>

                <p>
                  {' '}
                  For questions about Roche medicines or services, to report an adverse event (side effect) or product
                  quality defect or to submit a temperature excursion assessment, please visit MedInfo.roche.com or
                  phone 0800 276 243. Please refer to the Consumer Medicine Information on the{' '}
                  <a
                    href="https://www.medsafe.govt.nz/Consumers/CMI/v/vabysmo.pdf"
                    className="links"
                    title="Medsafe website"
                  >
                    Medsafe website
                  </a>{' '}
                  for product information applicable to New Zealand.
                </p>
              </Accordion.Body>
            </Accordion.Item>

            <Accordion.Item eventKey="7">
              <Accordion.Header>What if I am already on a treatment for my DMO?</Accordion.Header>
              <Accordion.Body>
                <p>
                  {' '}
                  If you are already on a vascular endothelial growth factor (VEGF) treatment, ask your Ophthalmologist
                  if switching to VABYSMO is right for you.
                </p>
              </Accordion.Body>
            </Accordion.Item>

            <Accordion.Item eventKey="8">
              <Accordion.Header>How much does VABYSMO cost?</Accordion.Header>
              <Accordion.Body>
                <p>
                  {' '}
                  VABYSMO is funded by PHARMAC for adults with wet AMD and DMO who meet predefined criteria. This means
                  there is no cost to the patient for the medicine itself. VABYSMO is not funded by PHARMAC for RVO.
                </p>
                <p>
                  {' '}
                  For patients ineligible for PHARMAC funded VABYSMO, Roche offers support through the VABYSMO Cost
                  Share Programme. The Programme helps with the cost of your medicine. Please speak with your
                  Ophthalmologist or nurse for details.
                </p>
                <p>
                  {' '}
                  If you have health insurance, check your policy carefully, as coverage can vary. Ask your
                  Ophthalmologist if VABYSMO is right for you. For more information, talk to your healthcare
                  professional or visit{' '}
                  <a
                    href="https://www.medsafe.govt.nz/Consumers/CMI/v/vabysmo.pdf"
                    className="links"
                    title="Medsafe website"
                  >
                    medsafe.govt.nz
                  </a>{' '}
                  for the VABYSMO Consumer Medicine Information
                </p>
              </Accordion.Body>
            </Accordion.Item>
          </Accordion>

          {/* New Section - FAQs about Macular Oedema Secondary to Retinal Vein Occlusion (RVO)  */}
          <div>
            <h3 className="font-color-secondary-3">
              <br />
              FAQs about Macular Oedema Secondary to Retinal Vein Occlusion (RVO)
              <br />{' '}
            </h3>
          </div>

          <Accordion>
            <Accordion.Item eventKey="0">
              <Accordion.Header>What is RVO?</Accordion.Header>
              <Accordion.Body>
                <p>
                  {' '}
                  RVO is a chronic eye condition that can lead to sudden painless vision loss and typically affects
                  only one eye.{' '}
                </p>
                <p>
                  {' '}
                  RVO prevents blood draining from the retina, which leads to bleeding and fluid leakage, causing
                  swelling in the macula.{' '}
                </p>
                <p>
                  {' '}
                  If untreated, RVO can lead to severe vision problems and even blindness, but VABYSMO can help reduce
                  the swelling and prevent vision loss.{' '}
                </p>
              </Accordion.Body>
            </Accordion.Item>
            <Accordion.Item eventKey="1">
              <Accordion.Header>How does RVO affect my vision? </Accordion.Header>
              <Accordion.Body>
                <p> While RVO affects everyone differently, its symptoms include: </p>
                <ul>
                  <li>Sudden painless blurring or vision loss in part of or all of one eye</li>
                  <li>Dark spots, little squiggles, or lines may appear in your vision</li>
                  <li>Colours might appear dull or faded</li>
                  <li>Vision may be blurred or wavy </li>
                  <li>Reading or driving may be difficult</li>
                </ul>
              </Accordion.Body>
            </Accordion.Item>

            <Accordion.Item eventKey="2">
              <Accordion.Header>What is "drying" and why is it important? </Accordion.Header>
              <Accordion.Body>
                <p>
                  {' '}
                  In RVO, blood and fluid can spill into the macula—the part of the eye that controls sharp,
                  straight-ahead vision.{' '}
                </p>
                <p> The macula swells, leading to blurred vision and vision loss. </p>
                <p> VABYSMO can help quickly dry the excess fluid. </p>
              </Accordion.Body>
            </Accordion.Item>

            <Accordion.Item eventKey="3">
              <Accordion.Header>What happens if I stop eye injections for RVO? </Accordion.Header>
              <Accordion.Body>
                <p>
                  {' '}
                  It’s important to keep up with your treatment for RVO. Keeping up with your treatment can prevent
                  blindness. Your Ophthalmologist can tell you more about what to expect from treatment with VABYSMO.
                </p>
              </Accordion.Body>
            </Accordion.Item>
          </Accordion>

          {/* FAQs about VABYSMO for Retinal Vein Occlusion (RVO) Section */}
          <div>
            <h3 className="font-color-secondary-3">
              <br />
              FAQs about VABYSMO for Retinal Vein Occlusion (RVO)
              <br />{' '}
            </h3>
          </div>

          <Accordion>
            <Accordion.Item eventKey="0">
              <Accordion.Header>What is VABYSMO?</Accordion.Header>
              <Accordion.Body>
                <p>
                  {' '}
                  VABYSMO is a prescription medicine administered by injection into the eye by your healthcare
                  professional.{' '}
                </p>
                <p>
                  {' '}
                  In New Zealand it is registered for the treatment of wet age-related macular degeneration (wet AMD),
                  diabetic macular oedema (DMO) and macular oedema secondary to retinal vein occlusion (RVO).{' '}
                </p>
              </Accordion.Body>
            </Accordion.Item>
            <Accordion.Item eventKey="1">
              <Accordion.Header>What are the serious side effects of VABYSMO?</Accordion.Header>
              <Accordion.Body>
                <p> VABYSMO may cause serious side effects, including: </p>
                <ul>
                  <li>
                    Pain, redness or blood around the coloured part of the eye bleeding into the eye causing a red tint
                    to your vision{' '}
                  </li>
                  <li>Blood or redness in the white part of the eye </li>
                  <li>
                    Increase in eye pressure – symptoms include severe headache, eye pain, nausea and vomiting, blurred
                    vision, eye redness{' '}
                  </li>
                  <li>Scratch to the clear part at the front of the eye </li>
                  <li>
                    Inflammation of the gel-like substance at the back of the eye – symptoms include hazy vision or a
                    marked increase in floaters{' '}
                  </li>
                  <li>
                    Sudden onset of the following: eye pain, increased discomfort, worsening eye redness, a higher
                    number of floaters in your vision, or increased sensitivity to light – these are signs of a possible
                    eye infection or inflammation{' '}
                  </li>
                  <li>
                    Decrease or change in your vision which can be sudden or gradual, including dim vision, difficulty
                    with vision at night, fading sudden, brief flashes of light which is more likely to occur when you
                    move your eye, heavy feeling in the eye{' '}
                  </li>
                </ul>
              </Accordion.Body>
            </Accordion.Item>

            <Accordion.Item eventKey="2">
              <Accordion.Header>What are the common side effects of VABYSMO? </Accordion.Header>
              <Accordion.Body>
                <p>
                  {' '}
                  The most common side effects with VABYSMO are cataract and blood on the white of the eye (conjunctival
                  haemorrhage). These are not all the possible side effects of VABYSMO.{' '}
                </p>
              </Accordion.Body>
            </Accordion.Item>

            <Accordion.Item eventKey="3">
              <Accordion.Header>How many injections will I receive with VABYSMO? </Accordion.Header>
              <Accordion.Body>
                <p>
                  {' '}
                  For people with RVO, VABYSMO is given every month for a minimum of 3 months. Afterwards, you may
                  receive injections less frequently. Depending on how you respond to treatment with VABYSMO, your
                  Ophthalmologist may ask you to change to a more or less frequent dose.
                </p>
              </Accordion.Body>
            </Accordion.Item>

            <Accordion.Item eventKey="4">
              <Accordion.Header>How fast does VABYSMO work? </Accordion.Header>
              <Accordion.Body>
                <p>
                  {' '}
                  Everyone is different, but studies show that VABYSMO may improve your vision after just 1 treatment.{' '}
                </p>
              </Accordion.Body>
            </Accordion.Item>

            <Accordion.Item eventKey="5">
              <Accordion.Header>How long will I need to receive VABYSMO? </Accordion.Header>
              <Accordion.Body>
                <p>
                  {' '}
                  RVO is a chronic condition that requires long-term care. Your Ophthalmologist can tell you more about
                  what to expect from treatment with VABYSMO.{' '}
                </p>
              </Accordion.Body>
            </Accordion.Item>

            <Accordion.Item eventKey="6">
              <Accordion.Header>What should I do if I experience a side effect? </Accordion.Header>
              <Accordion.Body>
                <p> Contact your Ophthalmologist if you think you might be experiencing any side effects. </p>
                <p>
                  {' '}
                  Call your doctor straight away or go to your nearest Accident and Emergency Centre if you notice any
                  of the following:
                  <br />
                  sudden vision loss or change in vision; signs of a possible eye infection or inflammation, such as
                  worsening redness of the eye or blood in and around the eye, eye pain, increased eye discomfort,
                  blurred or decreased vision, an increased number of floaters (small particles) in your vision,
                  increased sensitivity to light; you experience signs of a stroke, such as weakness or paralysis of
                  limbs or face or difficulty speaking.{' '}
                </p>
                <p>
                  {' '}
                  For questions about Roche medicines or services, to report an adverse event (side effect) or product
                  quality defect or to submit a temperature excursion assessment, please visit MedInfo.roche.com or
                  phone 0800 276 243. Please refer to the Consumer Medicine Information on the{' '}
                  <a
                    href="https://www.medsafe.govt.nz/Consumers/CMI/v/vabysmo.pdf"
                    className="links"
                    title="Medsafe website"
                  >
                    Medsafe website
                  </a>{' '}
                  for product information applicable to New Zealand.
                </p>
              </Accordion.Body>
            </Accordion.Item>

            <Accordion.Item eventKey="7">
              <Accordion.Header>What if I am already on a treatment for my RVO? </Accordion.Header>
              <Accordion.Body>
                <p>
                  {' '}
                  If you are already on an anti-vascular endothelial growth factor A (VEGF-A) treatment, ask your
                  Ophthalmologist if switching to VABYSMO is right for you.{' '}
                </p>
              </Accordion.Body>
            </Accordion.Item>
          </Accordion>
        </div>
        <ConsultDoctor bgColor="blue" />
        <Disclaimer />
        <ConsumerPanel />
      </Layout>
    );
  }
}

export default PatientPage;
